import { callToFetch } from "./shared.service";
import { coreServiceBaseUrl } from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";
import { deepCopyAndConvertToSnakeCase } from "@coworker/reusable/helpers/objectAccess";

const isChina = isChineseEnvironment();

export const CORE_SERVICE_URL = coreServiceBaseUrl(getEnvironmentId(), isChina);

export async function getGraphToken() {
  const path = `tokens/graph_token`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getStoreUsers(storeId) {
  const path = `users/store/${encodeURIComponent(storeId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getActiveStoreUsers(storeId) {
  const path = `users/active/store/${encodeURIComponent(storeId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getStoreTeams(storeId) {
  const path = `teams/store/${encodeURIComponent(storeId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getStoresByCountryId(countryId) {
  const path = `stores/country/${encodeURIComponent(countryId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getCountries() {
  const path = "countries/";
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getFocusTile(userLanguage) {
  const path = `upptacka-internal/focus-tiles/${userLanguage}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getUserIdsForTeamId(teamId) {
  const path = `users/v2/teamid/${encodeURIComponent(teamId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getStoreContacts(storeId) {
  const path = `stores/store-contacts/store/${encodeURIComponent(storeId)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  const result = await callToFetch("GET", url);
  return deepCopyAndConvertToSnakeCase(result);
}

export async function getUserPermissions(uid) {
  const path = `users/${uid}/permissions`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}

export async function getUserByUid(uid) {
  const path = `users/byUid/${encodeURIComponent(uid)}`;
  const url = `${CORE_SERVICE_URL}/${path}`;
  return callToFetch("GET", url);
}

export async function getAtkomstStores() {
  const path = "atkomst/stores";
  const url = `${CORE_SERVICE_URL}/${path}`;
  return await callToFetch("GET", url);
}
